import sectionFeaturedOfferCss from '../css-snippets/section-featured-offer';

const html = ` 
<style>${sectionFeaturedOfferCss}</style>
<div class="featured-offer-wrapper" data-id="unique-id" data-top-padding="true" data-bottom-padding="true">
  <div class="featured-offer-container container">
    <div class="featured-offer-title">
      <h2 style="text-align: center">
        <strong>Ready To Break The "Predictability Trap" Forever?</strong>
      </h2>
      <p style="text-align: center">
        Your kids (and pets) are craving the thrill of the hunt—that primal
        excitement that predictable toys simply can't deliver. This Electric
        Lizard with LED Glowing Eyes doesn't just entertain... it awakens those
        deep-seated instincts that make playtime irresistible.
      </p>
    </div>
    <div class="featured-offer-card-wrapper">
      <div class="featured-offer-card" data-image-position="left">
        <div class="featured-offer-card-image" data-image-show="true">
          <img src="https://cdn.skyfastimg.com/images/2025/12/12/image-693bbe3178a0e771c38f1ed4.avif?w=50&h=50&q=80" alt="image" />
        </div>
        <div class="featured-offer-card-content">
          <div class="featured-offer-card-content-header">
            <h2 style="text-align: center;">
              <span style="color:rgb(215,46,32)">UP TO 50% OFF</span>
            </h2>
            <h2 style="text-align: center">FOR A LIMITEDTIME ONLY!</h2>
            <p style="text-align: center">
              This limited-time deal is in high demand and stock keeps selling
              out.
            </p>
          </div>
          <div 
            class="featured-offer-card-content-button-wrapper" 
            data-show-btn="true"
            data-button-position="center"
          >
            <a href="#" class="featured-offer-card-content-button" data-button-animation-show="true">
              GET 50% OFF →
            </a>
          </div>
          <div class="featured-offer-card-content-footer">
            <p style="text-align: center">Try it today with a 90-Day Money Back Guarantee!</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;

export default html;
